import React from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';

export interface SeriesFilterProps {
  /** Selected series id. Use null for no filter */
  value: number | null;
  /** Called when selection changes; null means none selected */
  onChange: (value: number | null) => void;
  /** Optional compact sizing for icons (default 18) */
  iconSize?: number | string;
  /** Optional className for outer container */
  className?: string;
}

/**
 * Dropdown selector for delserie: Planlegging(1), Detaljer(2), Forvaltning(3).
 * Supports clearing selection via "Alle delserier" which yields null.
 */
const SeriesFilter: React.FC<SeriesFilterProps> = ({ value, onChange, className }) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    const raw = event.target.value;
    if (raw === '' || raw == null) {
      onChange(null);
    } else {
      const parsed = Number(raw);
      onChange(Number.isNaN(parsed) ? null : parsed);
    }
  };

  const renderValue = (selected: string) => {
    if (selected === '' || selected == null) return 'Alle delserier';
    switch (Number(selected)) {
      case 1:
        return 'Planlegging';
      case 2:
        return 'Byggdetaljer';
      case 3:
        return 'Byggforvaltning';
      default:
        return 'Alle delserier';
    }
  };

  return (
    <Box className={className} sx={{ display: 'flex', alignItems: 'center' }}>
      <FormControl size="small" variant="outlined" sx={{ minWidth: 220 }}>
        <InputLabel id="series-filter-label" shrink>
          Velg delserie
        </InputLabel>
        <Select
          labelId="series-filter-label"
          value={value == null ? '' : String(value)}
          onChange={handleChange}
          displayEmpty
          renderValue={renderValue}
          input={<OutlinedInput label="Velg delserie" notched />}
          sx={{ '& .MuiOutlinedInput-notchedOutline': { borderWidth: '1px' } }}>
          <MenuItem value="">
            <em>Alle delserier</em>
          </MenuItem>
          <MenuItem value={1}>Planlegging</MenuItem>
          <MenuItem value={2}>Byggdetaljer</MenuItem>
          <MenuItem value={3}>Byggforvaltning</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default SeriesFilter;
